import React from "react";
import "./ArtistCube.scss";
import { useContext } from "react";
import { AppContext } from "../../stores/application.store";
const ArtistCube = (props) => {
  const { bestArtists, toggleBestArtistVote } = useContext(AppContext);

  const ChooseArtistPress = (id, event) => {
    toggleBestArtistVote(props.artist.ID);
    event.stopPropagation();
  };
  return (
    <div className="artist-cube">
      <div
        onClick={() => toggleBestArtistVote(props.artist.ID)}
        className={`artist-image ${
          bestArtists.includes(props.artist.ID) ? "checked" : ""
        }
         image-${props.artist.ID}`}
      >
        {!bestArtists.includes(props.artist.ID) && !bestArtists.includes(0) && (
          <div className="fade"></div>
        )}
        <div
          className={`check-button`}
          onClick={(e) => ChooseArtistPress(props.artist.ID, e)}
        >
          <div className="desktop-only">בחירה</div>
        </div>
      </div>
      <h4 className="artist-name">{props.artist.Name}</h4>
    </div>
  );
};

export default ArtistCube;
